const KEY = "edu.communication-return.v1";
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
export function rememberCommunicationRoute(path: string) {
  const id = /^\/communications\/([^/]+)$/.exec(path)?.[1];
  if (!id || !UUID.test(id)) return;
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ id, at: Date.now() }));
  } catch {
    /* Storage opcional. */
  }
}
export function pendingCommunicationRoute() {
  try {
    const raw = JSON.parse(sessionStorage.getItem(KEY) ?? "null");
    return raw &&
      typeof raw.id === "string" &&
      UUID.test(raw.id) &&
      typeof raw.at === "number" &&
      raw.at <= Date.now() &&
      Date.now() - raw.at < 900000
      ? { to: "/communications/$id" as const, params: { id: raw.id as string } }
      : null;
  } catch {
    return null;
  }
}
export function clearCommunicationRoute(id: string) {
  if (pendingCommunicationRoute()?.params.id === id)
    try {
      sessionStorage.removeItem(KEY);
    } catch {
      /* Storage opcional. */
    }
}
